const SYMBOL_INDEX_AFTER_GA_PREFIX = 2;

// "gaEventValue" -> "eventValue"
// "gaEventSportId" -> "eventSportId"
export function removeGaPrefix(key: `ga${string}`) {
  return key[SYMBOL_INDEX_AFTER_GA_PREFIX].toLowerCase() + key.slice(3);
}
